<script>
  import { userStore } from '../store'
  import LoginPopup from './LoginPopup.svelte'
  import { User } from '../roles'
  let user = new User()
</script>

{#if $userStore.blocked}
  <div class="absolute top-0 left-0 w-screen h-screen bg-opacity-50 bg-gray-900
              flex justify-center items-center" style="z-index: 9000;">

    <div class="px-16 pt-48 pb-32 rounded bg-white">

      <div class="text-xl text-gray-700">
        <p class="mb-2">
          Sorry, access is restricted
        </p>
        <p>
          Please contact
          <span class="text-red-600 cursor-pointer">
            <a href="https://software.support.flexlink.io/support/home">FlexLink Software support</a>
          </span>
        </p>
        <p class="pt-10 cursor-pointer text-red-600 text-base" on:click={() => { user.logout() }}>
          Sign in with another account
        </p>
      </div>

    </div>

  </div>

{:else}

  <LoginPopup />

{/if}